import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/billers/actions";
import { Table, message } from "antd";

const CategoryDetail = () => {
  const dispatch = useDispatch();

  const { categories, loading, error } = useSelector(
    (state) => state?.BillerReducer || {}
  );

  // pagination state
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  useEffect(() => {
    dispatch(actions.getCategories());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      message.error(error);
    }
  }, [error]);

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 60,
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1, // ✅ continuous row number
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "AGT",
      dataIndex: "AGT",
      key: "AGT",
    },
    {
      title: "MOB",
      dataIndex: "MOB",
      key: "MOB",
    },
    {
      title: "INT",
      dataIndex: "INT",
      key: "INT",
    },
    {
      title: "Total Billers",
      dataIndex: "totalBillers",
      key: "totalBillers",
    },
  ];

  const dataSource = Array.isArray(categories) ? categories : [];

  return (
    <div style={{ paddingLeft: "40px" }}>
      <h1 style={{ marginBottom: "20px" }}>All Categories</h1>

      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey={(record, index) => index}
        bordered
        loading={loading} // ✅ spinner inside table
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          onChange: (page, pageSize) => {
            setPagination({ current: page, pageSize });
          },
        }}
      />
    </div>
  );
};

export default CategoryDetail;
